import Vue from 'vue'
import Vuex from 'vuex'

import user from './modules/user'
import app from './modules/app.js'
import wallet from './modules/wallet.js'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        key: 'jlw',
        iv: 'jlw'
    },
    modules: {
        user: {
            namespaced: true,
            ...user
        },
        app: {
            namespaced: true,
            ...app
        },
        wallet: {
            namespaced: true,
            ...wallet
        }
    }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js